import { render } from "./ChoicenessList.vue?vue&type=template&id=f250c298&scoped=true"
import script from "./ChoicenessList.vue?vue&type=script&lang=js"
export * from "./ChoicenessList.vue?vue&type=script&lang=js"

import "./ChoicenessList.vue?vue&type=style&index=0&id=f250c298&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f250c298"]])

export default __exports__